import useImage from '../hooks/useImage';
import { staticStringOptionReplace } from './constants.ts';

export function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Android';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
}

export function replaceStaticName(text) {
  let result = '';

  if (text) {
    const arrayOfNames = staticStringOptionReplace;
    arrayOfNames.map((content) => {
      let rExp = new RegExp(content, 'g');
      result = text.replace(rExp, '');
    });
  }

  return result;
}

export function MobileOs() {
  let result = 'desktop';
  var userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.indexOf('android') !== -1) {
    result = 'android';
    console.log('Операционная система: Android');
  } else if (
    userAgent.indexOf('iphone') !== -1 ||
    userAgent.indexOf('ipad') !== -1 ||
    userAgent.indexOf('ipod') !== -1
  ) {
    result = 'ios';
    console.log('Операционная система: iOS');
  } else if (
    userAgent.indexOf('windows') !== -1 ||
    userAgent.indexOf('mac') !== -1
  ) {
    result = 'desktop';
    console.log('Операционная система: Компьютер/Ноутбук');
  } else {
    result = 'desktop';
    console.log('Операционная система не определена.');
  }

  return result;
}

export function NoImage() {
  // Return empty string as placeholder
  return '';
}

export function getValidSortValues(value, setValue) {
  let sortAttr = value;
  sortAttr.sort(function (a, b) {
    if (a.metadata._sort && b.metadata._sort) {
      return a.metadata._sort - b.metadata._sort;
    } else {
      return 0;
    }
  });

  setValue(sortAttr);
}

export function moveNoneToFirstPosition(array) {
  // Ищем первый объект с именем "None"
  const noneObject = array.find((obj) => obj.name === 'None');

  // Если такой объект найден, перемещаем его в начало массива
  if (noneObject) {
    // Удаляем объект с именем "None" из массива
    const index = array.indexOf(noneObject);
    array.splice(index, 1);

    // Добавляем объект с именем "None" в начало массива
    array.unshift(noneObject);
  }

  // Возвращаем измененный массив
  return array;
}
